import React from "react";
import { Col, FormControl, FormGroup, FormLabel, Row } from "react-bootstrap";
import { InputBox } from "../../components";
import { AccountInterface, ApiHelper, CommentInterface, DateHelper, EnvironmentHelper, SupportTicketInterface, UserHelper } from "../../helpers";
import { FileHelper } from "../../helpers/FileHelper";

interface Props {
  ticket: SupportTicketInterface,
  onDone: () => void
}


export const TicketDetails: React.FC<Props> = props => {

  const [comments, setComments] = React.useState<CommentInterface[]>([]);
  const [account, setAccount] = React.useState<AccountInterface>(null);
  const [commentText, setCommentText] = React.useState("");
  const [attachments, setAttachments] = React.useState<string[]>([])

  const init = () => {
    setComments([]);
    if (props.ticket?.id > 0) {
      ApiHelper.get<CommentInterface[]>("/comments/ticket/" + props.ticket.id).then(data => setComments(data || []));
      ApiHelper.get<AccountInterface>("/accounts/" + props.ticket.accountId).then(data => setAccount(data));
      ApiHelper.get<string[]>("/files/supporttickets/" + props.ticket.id).then(data => setAttachments(data || []));
    } else {
      ApiHelper.get<AccountInterface>("/accounts/" + UserHelper.currentDepartment.accountId).then(data => setAccount(data));
    }
  }

  React.useEffect(init, [props.ticket]);

  const handleChange = (e: any) => {
    const val = e.currentTarget.value;
    switch (e.currentTarget.id) {
      case "commentText": setCommentText(val); break;
    }
  }

  const getComments = () => {
    const result: React.ReactElement[] = [];
    comments?.forEach(c => {
      result.push(<div className="comment">
        <div className="commentHeader">
          <b>{c.user?.email}</b> | {DateHelper.getDisplayDuration(DateHelper.convertToDate(c.postTime))}
        </div>
        <div dangerouslySetInnerHTML={{ __html: c.body.replace("\n", "<br />") }} ></div>
      </div>)
    })
    return result;
  }

  const handlePost = async () => {
    let ticketId = props.ticket.id || 0
    if (ticketId === 0) {
      const ticket = await ApiHelper.post<{ id: number }>("/supportTickets/create", {});
      ticketId = ticket?.id || 0;
    }
    ApiHelper.post("/comments/add", { supportTicketId: ticketId, commentBody: commentText }).then(() => { props.onDone() });
  }

  const toggleStatus = (e: React.MouseEvent) => {
    e.preventDefault();
    let status = (props.ticket.status === "Open") ? "Closed" : "Open";
    ApiHelper.post("/supportTickets/updateStatus", { ticketId: props.ticket.id, status: status }).then(() => { props.onDone() });
  }

  const getTicketDetails = () => {
    const status = (UserHelper.checkAccess("admin"))
      ? <a href="about:blank" onClick={toggleStatus}>{props.ticket?.status}</a>
      : props.ticket?.status;
    if (props.ticket?.id > 0) return (<>
      <div>Account: {account?.name}</div>
      <Row>
        <Col>Ticket #{props.ticket?.id}</Col>
        <Col>Status: {status}</Col>
      </Row>
      <hr />
    </>);
  }

  const handleFileChange = async () => {
    const fileId = "supportUpload";
    const field: any = document.getElementById(fileId);
    const f = field.files[0];
    await FileHelper.preUpload("supportTicket", props.ticket.id, 0, f, f.name, () => { });
    init();
  }

  const getUploadButton = () => {
    return (<>
      <a href="about:blank" onClick={(e) => { e.preventDefault(); document.getElementById("supportUpload").click(); }} className="btn btn-success" >Upload Attachment</a>
      <input type="file" style={{ display: "none" }} id="supportUpload" onChange={handleFileChange} />
    </>);
  }

  const getAttachments = () => {
    if (props.ticket?.id > 0) {
      if (attachments.length === 0) return <><p>There are no attachments</p>{getUploadButton()}</>
      else {
        const items: React.ReactElement[] = [];
        attachments.forEach(a => {
          items.push(<li><a href={EnvironmentHelper.ContentRoot + "/supporttickets/" + props.ticket?.id + "/" + a}>{a}</a></li>)
        });
        return (<><ul>{items}</ul>{getUploadButton()}</>);
      }
    }
    else return <p>You will be able to add attachments after submitting the ticket.</p>
  }

  return <InputBox headerText="Support Ticket" headerIcon="fas fa-users" saveFunction={handlePost} saveText="Post"  >
    {getTicketDetails()}
    <div><b>Attachments</b></div>
    {getAttachments()}
    <hr />
    <b>Comments</b>
    {getComments()}
    <br />

    <FormGroup className="mb-3">
      <FormLabel>Add a comment</FormLabel>
      <FormControl as="textarea" id="commentText" value={commentText} onChange={handleChange} />
    </FormGroup>
  </InputBox>

};